(function () {
    'use strict';

    angular.module("imApp").factory("productionRoutingMenuService", [function () {
        let service = {};

        return service;
    }]);
})();
